import { TextField } from "@mui/material";
import React, { PropsWithChildren, type JSX } from 'react';
import { SideSheetFieldPropsBase } from "../side-sheet/SideSheet";

export type SideSheetSelectProps = {
    value: string;
    onChange?: (value: string) => void;
} & SideSheetFieldPropsBase;

export default function SideSheetSelect({
    id,
    testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    sx,
    disabled,
    value,
    children,
    onChange
}: PropsWithChildren<SideSheetSelectProps>): JSX.Element {

    return (
        <TextField
            variant="filled"
            select
            id={id}
            data-testid={testId}
            aria-label={ariaLabel}
            sx={{
                marginTop: 0,
                ...sx
            }}
            label={label}
            helperText={helperText}
            onChange={
                (e) => {
                    onChange && onChange(e.target.value);
                }
            }
            value={value}
            disabled={disabled}
            slotProps={{
                input: {
                    readOnly: readOnly
                },

                inputLabel: {
                    shrink: true,
                }
            }}>
            {children}
        </TextField>
    );
}